module.exports = __webpack_public_path__ + "img/12.0ff610c3.jpg";